import { defaultEdgeOptions } from '@ui/lib/reactFlow/helpers'
import { useMemo } from 'react'
import { BaseEdge, EdgeProps, getSmoothStepPath } from 'reactflow'

import { getMarkerId } from '@xyflow/system'

export const LogEdge = (props: EdgeProps) => {
  const [edgePath] = getSmoothStepPath({
    sourceX: props.sourceX - 55,
    sourceY: props.sourceY,
    sourcePosition: props.sourcePosition,
    targetX: props.targetX + 25,
    targetY: props.targetY,
    targetPosition: props.targetPosition,
  })

  const rfId = '1' // This is a gloabl unique ID for reactflow. Not sure where to pull it from, but it's going to be 1.
  const markerEnd = defaultEdgeOptions.markerEnd
  const markerEndUrl = useMemo(() => `url(#${getMarkerId(markerEnd, rfId)})`, [markerEnd, rfId])

  return (
    <>
      <BaseEdge markerEnd={markerEndUrl} path={edgePath} style={{ strokeWidth: 2, stroke: '#324AA6', opacity: 1 }} />
    </>
  )
}
